import { Box, useToast } from "@chakra-ui/react";
import React, {
  Suspense,
  lazy,
  useEffect,
  useState,
  useTransition,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import DisplayArea from "./DisplayArea";
import AuthDisplayArea from "./AuthDisplayArea";
import CustomToast from "./CustomToast";

import {
  clearWholeLocalStorage,
  getAuthToken,
  getCurrentDeviceDetails,
  getUserDetails,
  setCurrentDeviceDetails,
  setTempCurrentDeviceDetails,
} from "utils/local-storage";

import { markAuthStore } from "stores/auth/authSlice";
import PrintIPN from "pages/PrintIPN";

// ✅ Lazy-loaded components
const AdswordTracker = lazy(() => import("components/Topbar/AdswordTracker"));
// const ChatSupport = lazy(() => import("./ChatSupport"));
const CookiesBar = lazy(() => import("./CookiesBar"));
const GtmTagManager = lazy(() => import("./Topbar/GtmTagManager"));

const Layout = ({ children }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [, startTransition] = useTransition();
  const { pathname } = useLocation();
  const [redirecting, setRedirecting] = useState(true);
  const isIndexPage =
    pathname === "/" ||
    pathname === "/registeruser" ||
    pathname === "/forgotPassword" ||
    pathname === "/loginWithOtp" ||
    pathname.includes("/resetPassword") ||
    pathname.includes("/activation") ||
    pathname.includes("/privacy-and-policy");

  const isUnsubscribeEmailPage = pathname.includes("/UnsubscribeEmail");
  const isActivationPage = pathname.includes("/activation");
  const userDetails = getUserDetails();
  const authToken = getAuthToken();
  const localCurrentDevice = getCurrentDeviceDetails();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isUnsubscribeEmailPage) {
      setRedirecting(false);
      return;
    }
    if(isActivationPage){
      setRedirecting(false);
      return;
    }
    if (authToken) {
      if (userDetails) {
        if (localCurrentDevice) {
          const { email_status, devices, email } = userDetails;
          dispatch(
            markAuthStore({
              userDetails: {
                email,
                devices,
                email_status,
              },
              currentDevice: localCurrentDevice,
              family: localCurrentDevice.family,
            })
          );
          if (isIndexPage) {
            startTransition(() => {
              navigate(
                "/dashboard",
                { replace: true }
              );
              setRedirecting(false);
            });
          } else {
            startTransition(() => {
              navigate(pathname, { replace: true });
              setRedirecting(false);
            });
          }
        } else {
          const { email_status, devices, email } = userDetails;
          dispatch(
            markAuthStore({
              userDetails: {
                email,
                devices,
                email_status,
              },
              currentDevice: devices[0] ?? null,
              family: devices[0]?.family ?? 1,
            })
          );
          if (devices?.length === 0) {
            startTransition(() => {
              navigate("/dashboard", { replace: true });
              setRedirecting(false);
            });
          } else {
            startTransition(() => {
              navigate(pathname, { replace: true });
              setRedirecting(false);
            });
            setCurrentDeviceDetails(devices[0]);
            setTempCurrentDeviceDetails(devices[0]);
          }
        }
      } else {
        clearWholeLocalStorage();
        toast({
          position: "top-right",
          status: "warning",
          render: () => (
            <CustomToast bgColor={"red"} message={"Session Expired..."} />
          ),
        });
        startTransition(() => {
          navigate("/", { replace: true });
          setRedirecting(false);
        });
      }
    } else {
      if (isIndexPage) {
        clearWholeLocalStorage();
        startTransition(() => {
          navigate(pathname, { replace: true });
          setRedirecting(false);
        });
      } else {
        clearWholeLocalStorage();
        startTransition(() => {
          navigate("/", { replace: true });
          setRedirecting(false);
        });
      }
    }
  }, [navigate, pathname]);

  if (pathname.includes("printIPN")) {
    return (
      <Suspense fallback={<></>}>
        <PrintIPN />
      </Suspense>
    );
  }

  if (redirecting) return <AuthDisplayArea />;
  return (
    <Suspense fallback={<></>}>
      <>
        {!isIndexPage && (
          <>
            <Box display={"flex"} minH="100vh" h="100%" position={"relative"}>
              <Box w="full" bg={`#ffffff`} minH={"100%"}>
                <Suspense fallback={<></>}>
                  <AdswordTracker />
                </Suspense>

                <DisplayArea>{children}</DisplayArea>
              </Box>
            </Box>
          </>
        )}{" "}
        {isIndexPage && (
          <Box display={"flex"} minH="100vh" h="100%" position={"relative"}>
            <Box w="full" bg={`#ffffff`} minH={"100%"}>
              <AuthDisplayArea> {children}</AuthDisplayArea>
            </Box>
          </Box>
        )}
        {/* <Suspense fallback={<></>}>
          <ChatSupport />
        </Suspense> */}
        <Suspense fallback={<></>}>
          <GtmTagManager />
        </Suspense>
        <Suspense fallback={<></>}>
          <CookiesBar />
        </Suspense>
      </>
    </Suspense>
  );
};

export default Layout;
